import { ReactElement } from "react";
import { Button } from "@/components/ui/button"
import { useI18n } from "src/i18n/I18nContext";


export interface SubmitButtonProps {
    caption?: string;
    isSubmitting?: boolean;
    loadingText?: string;
    // add spread props to have better control
    [key: string]: any;
}

const SubmitButton = ({ caption, isSubmitting, loadingText, ...rest }: SubmitButtonProps): ReactElement => {
    const { t } = useI18n();

    return (<Button
        colorPalette='blue'
        type='submit'
        loading={isSubmitting}
        loadingText={loadingText ?? t('common.submitting')}
        {...rest}
    >{caption ?? t('common.save')}</Button>)
}


export default SubmitButton
